<script setup lang="ts">
  import { Loader2 } from 'lucide-vue-next';
  import { ActionButtons } from '@/shared/ui';
  import { TRAINING_TYPE_LABELS } from '@/entities/Training';
  import { useEditTraining } from '../model/useEditTraining';
  import OnboardingForm from './onboarding/OnboardingForm.vue';
  import RoleChangeForm from './role-change/RoleChangeForm.vue';
  import SgqPunctualForm from './sgq-punctual/SgqPunctualForm.vue';
  import OpenTrainingForm from './open-training/OpenTrainingForm.vue';
  import EditHomologationTrainingForm from './edit/EditHomologationTrainingForm.vue';

  const { loading, training, onboarding, roleChange, sgqPunctual, openTraining, homologation, canSave, saving, save } =
    useEditTraining();
</script>

<template>
  <div
    data-testid="edit-training-page"
    class="flex h-full flex-col gap-6 p-6"
  >
    <div
      v-if="loading"
      data-testid="edit-training-loading"
      class="flex flex-1 items-center justify-center"
    >
      <Loader2 class="h-6 w-6 animate-spin text-[var(--theme-secondary-ink)]" />
    </div>

    <template v-else-if="training">
      <h1
        data-testid="edit-training-title"
        class="text-xl font-semibold text-gray-07"
      >
        Editar Treinamento
      </h1>

      <div class="flex flex-col">
        <section class="flex flex-col gap-4 border-b border-gray-02 px-6 py-8">
          <div class="flex flex-col gap-2">
            <span class="text-xs font-semibold text-gray-07">Tipo de Treinamento</span>
            <span
              data-testid="edit-training-type"
              class="w-fit rounded-2xl border border-border-color bg-gray-02/20 px-5 py-3.5 text-sm text-gray-07"
            >
              {{ TRAINING_TYPE_LABELS[training.type] }}
            </span>
          </div>
        </section>

        <OnboardingForm
          v-if="training.type === 'ONBOARDING' && onboarding"
          :form="onboarding"
        />
        <RoleChangeForm
          v-if="training.type === 'ROLE_CHANGE' && roleChange"
          :form="roleChange"
        />
        <SgqPunctualForm
          v-if="training.type === 'SGQ_DOCUMENT_FOCAL' && sgqPunctual"
          :form="sgqPunctual"
        />
        <OpenTrainingForm
          v-if="training.type === 'OPEN_TRAINING' && openTraining"
          :form="openTraining"
        />
        <EditHomologationTrainingForm
          v-if="training.type === 'SGQ_DOCUMENT_HOMOLOGATION' && homologation"
          :training="training"
          :form="homologation"
        />
      </div>

      <div
        data-testid="edit-training-actions"
        class="mt-auto"
      >
        <ActionButtons
          :cancel-route="{ name: 'TreinamentosListaTreinamentos' }"
          :disabled="!canSave || saving"
          :loading="saving"
          @save="save"
        />
      </div>
    </template>
  </div>
</template>
